import ApiRoot from "./apiRoot"
import { CollegeName } from "data"
import { ClientData } from "types"

export class ClientApi extends ApiRoot {
  static find({ cid }: { cid: string }): Promise<Client> {
    if (!this.connection) {
      throw new Error("Connection not initialized")
    }
    return this.connection.get(`/clients/${cid}`).then(response => {
      return response.data
    })
  }
}

export interface Client {
  cid: string
  data: ClientData
  redirectUrl: string
  adb2cUrl: string
  theme: CollegeName | "base"
}
